import * as React from 'react';
import { list } from 'mc/lib';
import ParovaniPlatebApi from '../api/gen/pohledavky/ParovaniPlatebApi';

export const PLATBY_LIST_AREA = 'platbyList';
export const BANKOVNI_UCTY_LIST_AREA = 'bankovniUctyList';

/**
 * Akce pro modul párování
 */

export function fetchPlatbyIfNeeded(forced: boolean = false) {
    return list.SimpleListActions.fetchIfNeeded(PLATBY_LIST_AREA, undefined, (parent, filter) => {
        return ParovaniPlatebApi.findPlatbyByFilter(filter, 100);
    }, forced);
}

export function filterPlatby(filter: any) {
    return list.SimpleListActions.filter(PLATBY_LIST_AREA, filter);
}

export function invalidatePlatby() {
    return list.SimpleListActions.invalidate(PLATBY_LIST_AREA);
}

export function fetchBankovniUctyIfNeeded(kodTypPripad: string, forced: boolean = false) {
    return list.SimpleListActions.fetchIfNeeded(BANKOVNI_UCTY_LIST_AREA, kodTypPripad, () => {
        return ParovaniPlatebApi.findBankovniUcty(kodTypPripad);
    }, forced);
}
